import {
  Component, EventEmitter, OnInit, Output
} from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

import { LooseArticleRootCategory } from 'app/constants/loose-article-categories.data';

@Component({
  selector: 'app-loose-categories',
  templateUrl: './loose-categories.component.html',
  styleUrls: ['./loose-categories.component.scss']
})
export class LooseCategoriesComponent implements OnInit {
  @Output() onSelectItem = new EventEmitter<string>();

  categories$: Observable<LooseArticleRootCategory[]> = of([]);

  parentCatIndex = 0;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.categories$ = from(
      fetch('./assets/common/loose-article-categories.json').then((res) => res.json())
    ).pipe(take(1));
  }

  onSelect(id: string): void {
    this.onSelectItem.emit(id);
  }

  setParentCatIndex(i: number): void {
    this.parentCatIndex = i;
  }
}
